<script>
import EventDetailModal from './EventDetailModal.vue';
import { get as _get } from 'lodash';
import { handleValidPolicy } from './utils/eventCommon';
export default {
  name: 'EventEditModal',
  extends: EventDetailModal,
  data() {
    return {
      mode: 'modify'
    };
  },
  methods: {
    onConfirmOk() {
      let body = {};
      let policy = {};
      let rule = this.ruleModel;
      policy.eventOccurTimeZone = rule.eventOccurTimeZone;
      policy.eventLevel = rule.eventLevel;
      policy.disableYn = rule.disableYn;
      policy.eventMessagePrefix = this.$util.isNotEmpty(rule.prefix) ? rule.prefix : '';

      policy.ftCount = Number(rule.ftCount);
      //policy.isLogMetric = rule.isLogMetric; 수정시에는 안쓴다.
      policy.metricKey = rule.metricKey;
      if (rule.isDeletedIndividualItem) {
        rule.objectModel = '';
      }
      const resourceTypeModel = _get(this, 'detailData.productSummary.productTypeCode', '');
      const resourceTypeModel2 = _get(this, 'detailData.objectType', '');
      if (
        (resourceTypeModel === 'Kubernetes' && resourceTypeModel2 !== 'cluster') ||
        (['DataOps', 'DataFlow', 'Load Balancer'].includes(resourceTypeModel) &&
          resourceTypeModel2 !== 'service') ||
        (['QuickQuery', 'DataWrangler'].includes(resourceTypeModel) &&
          resourceTypeModel2 !== 'namespace')
      ) {
        policy.objectName =
          this.detailData.productSummary.productSubName || this.detailData.objectName;
        policy.objectDisplayName =
          this.detailData.productSummary.productSubName || this.detailData.objectDisplayName;

        const hasIndividualItems = rule.isObjectExist === 'Y' && rule.disableObject !== 'Y';
        if (hasIndividualItems) {
          const { value, text } = rule.objectItems.find((e) => e.value == rule.objectModel) || {};
          policy.podObjectName = value;
          policy.podObjectDisplayName = text;
        }

        policy.objectType =
          this.detailData.productSummary.productSubType || this.detailData.objectType;
        policy.objectTypeName =
          this.detailData.productSummary.productSubType || this.detailData.objectTypeName;
      } else {
        policy.objectDisplayName = rule.objectModel;
        // 단일 상품일 경우
        if (rule.isObjectExist == 'Y') {
          if (Array.isArray(rule.objectItems)) {
            let _objectModel =
              rule.objectItems.find((item) => {
                return item.value == rule.objectModel;
              }) || {};
            policy.objectName = rule.objectModel;
            policy.objectDisplayName = _objectModel.text || rule.objectModel;
          }
        }
        policy.objectTypeName = this.objectTypeName;
        policy.objectType = this.objectType;
      }
      body.eventPolicyRequest = handleValidPolicy(rule, policy);

      let levelList = ['FATAL', 'WARNING', 'INFORM'];
      let notificationRecipients = [];
      this.notificationsModel.forEach((item) => {
        let recipient = {};
        recipient.notificationMethods = [];
        for (let i in levelList) {
          let level = levelList[i];
          let method = item.notificationMethods.find((noti) => noti.eventLevel == level);
          recipient.notificationMethods.push(method);
        }
        if (recipient.notificationMethods.length > 0) {
          recipient.recipientKey = item.recipientKey;
          recipient.recipientType = item.recipientType;
          notificationRecipients.push(recipient);
        }
      });
      body.notificationRecipients = notificationRecipients;

      this.$http.event
        .put(`/v1/console/event-policies/${this.seq}`, body, true, false, {
          headers: { 'X-ResourceType': this.resourceType }
        })
        .then(() => {
          this.$store.dispatch('notify/needCheckNotifications');
          this.$toast.open(this.$t('toast.eventPolicy.modifySuccess'));
          this.$emit('confirm');
          this.closeModal();
        })
        .catch(() => {
          this.$toast.open(this.$t('toast.eventPolicy.modifyFail'));
          this.closeModal();
        });
    },
    onConfirmClick() {
      if (!this.$refs.ruleItem.validate()) {
        console.warn('not validate');
        return false;
      }
      let notificationLen = this.notificationsModel.length;
      if (notificationLen > 20) {
        this.$alert(this.t('page.eventStatus.notificationsRegister'));
        return false;
      }

      const checkIsNotificationMethod = this.notificationsModel.find(
        (e) => e.notificationMethods[0].sendMethod.length === 0
      );
      if (checkIsNotificationMethod) {
        this.$alert(this.t('page.eventStatus.noNotificationMethod'));
        return false;
      }
      this.$alert(this.t('page.template.modifyOk'), {
        cancel: () => {},
        action: () => {
          this.onConfirmOk();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles/eventDetailModal.scss';
$layoutSelectboxColHeight: 702px;
:deep(.text-item-wrap) {
  color: #2e3138;

  .text-label,
  .text-field {
    color: #2e3138 !important;
  }

  .text-field-wrap {
    margin-top: 8px;
    padding: 0;
  }
}

.lego-tab__label-underline {
  color: #2e3138;
  border-bottom: 1px solid #e3e4e8;
  &--active {
    color: #2c5ad8;
    border-bottom-color: #2c5ad8;
  }
}
.lego-tab__label-underline:hover {
  color: #2c5ad8 !important;
}
:deep(.lego-tab__content-wrapper) {
  border-top: 1px solid #e3e4e8;
}
.tab-wrapper {
  .tabbox {
    &-item {
      height: 54px;
      padding: 0 32px;
    }
  }
}
.select-formbox-wrap {
  display: flex;
  justify-content: center;

  .selectbox-col {
    width: 278px;
    height: $layoutSelectboxColHeight;
    border-right: 1px solid rgb(227, 229, 232);
    margin: 24px 0;
    .height-scroll {
      height: $layoutSelectboxColHeight;
    }
  }
  & .formbox-col {
    width: calc(100% - 278px);
    padding: 0 0 0 24px;
  }
}
.history-tab {
  width: 1232px;
  border-bottom: 1px solid #d2d3d6;
}
.target-grid {
  padding: 0px 20px 0px 0px;
  .target-item__value {
    word-break: break-word;
  }
  .asg-product-name {
    background: #eef2fc;
    border-radius: 100px;
    padding: 6px;
    margin-top: 5px;
    font-size: 14px;
  }
  .server-list {
    margin-top: 36px;
  }
}
:deep(.scpm-insight-chart-container) {
  width: unset !important;
}
</style>
